export const cilWrapText = ["24 24","<path d='M0.75 10.875h7.5v1.5h-7.5v-1.5z'></path><path d='M0.75 18.375h18.375v1.5h-18.375v-1.5z'></path><path d='M19.125 3.375h-18.375v1.5h18.375c1.447 0 2.625 1.346 2.625 3s-1.178 3-2.625 3h-2.962v-3.245l-6.319 4.042 6.319 3.927v-3.224h2.962c2.275 0 4.125-2.019 4.125-4.5s-1.85-4.5-4.125-4.5zM14.663 12.901l-2.007-1.247 2.007-1.284z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-wrap-text.js
// module id = null
// module chunks = 